import { Box } from '@material-ui/core';
import React, { CSSProperties } from 'react';
import { formatInCurrency } from '../common/formatters';
import { Typography } from '../common/Typography';
import { PayInvoicesButton } from './PayInvoicesButton';
import { BillingTableItem } from './types';
import { useUnpaidBillingItems } from './useUnpaidBillingItems';

const textStyle: CSSProperties = { marginRight: 12, verticalAlign: 'middle' };

const BottomBar: React.FC = ({ children }) => (
  <Box
    position={'fixed'}
    bottom={0}
    left={0}
    bgcolor={'white'}
    p={2}
    width={'100%'}
    textAlign={'right'}
    boxShadow={'0px -4px 20px rgba(0, 0, 0, 0.25)'}
    paddingRight={10}
  >
    {children}
  </Box>
);

interface PayNowBarProps {
  items: BillingTableItem[];
  currencyOptions: Intl.NumberFormatOptions;
}

export const PayNowBar: React.FC<PayNowBarProps> = ({ items, currencyOptions }) => {
  const { balance, unpaidInvoices } = useUnpaidBillingItems(items);

  if (!items.length) {
    return null;
  }

  return (
    <BottomBar>
      <Typography variant={'h4'} color={'textPrimary'} component={'span'} style={textStyle}>
        {`${currencyOptions.currency} ${formatInCurrency(balance, currencyOptions)}`}
      </Typography>
      <PayInvoicesButton billingItems={unpaidInvoices}>Pay Now</PayInvoicesButton>
    </BottomBar>
  );
};
